window.DetalheClienteView = Backbone.Marionette.CompositeView.extend({
    template: "#template-detalhe-cliente",

    initialize: function(options) {
        this.app = options.app;
    },

    render: function() {
        this.$el.html(Mustache.render($(this.template).html(), this.model.toJSON()));
    }
});